export default __webpack_public_path__ + "static/media/alur-2.1c1fa4fb.png";